import { queryOptions } from '@tanstack/react-query';

import associateProfileService from './associateProfileService';

// **** Queries **** //

export const getAssociateProfileQueryOptions = {
  profile: (alias: string, siteId: number) =>
    queryOptions({
      queryKey: ['associateProfile', alias, siteId] as const,
      queryFn: async ({ signal }) =>
        (await associateProfileService.getAssociateProfile(alias, siteId, { signal })).data,
      enabled: !!alias && siteId !== 0,
    }),

  placements: (alias: string, siteId: number) =>
    queryOptions({
      queryKey: ['associateProfile', alias, siteId, 'placements'] as const,
      queryFn: async ({ signal }) =>
        (await associateProfileService.getAssociateProfilePlacements(alias, siteId, { signal })).data,
      enabled: !!alias && siteId !== 0,
    }),

  restrictions: (alias: string, siteId: number) =>
    queryOptions({
      queryKey: ['associateProfile', alias, siteId, 'restrictions'] as const,
      queryFn: async ({ signal }) =>
        (await associateProfileService.getAssociateProfileRestrictions(alias, siteId, { signal })).data,
      enabled: !!alias && siteId !== 0,
    }),

  history: (alias: string, siteId: number) =>
    queryOptions({
      queryKey: ['associateProfile', alias, siteId, 'history'] as const,
      queryFn: async ({ signal }) =>
        (await associateProfileService.getAssociateProfileHistory(alias, siteId, { signal })).data,
      enabled: !!alias && siteId !== 0,
    }),

  lastPlacementDate: (alias: string, siteId: number) =>
    queryOptions({
      queryKey: ['associateProfile', alias, siteId, 'lastPlacementDate'] as const,
      queryFn: async ({ signal }) =>
        (await associateProfileService.getLastPlacementDate(alias, siteId, { signal })).data,
      enabled: !!alias && siteId !== 0,
    }),

  modifiedDutySummary: (alias: string) =>
    queryOptions({
      queryKey: ['associateProfile', alias, 'modifiedDutySummary'] as const,
      queryFn: async ({ signal }) => (await associateProfileService.getModifiedDutySummary(alias, { signal })).data,
      enabled: !!alias,
    }),
};
